var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trait-container"},[_c('div',{staticClass:"trait-type"},[_vm._v(_vm._s(_vm.$props.traitType))]),_c('div',{staticClass:"trait-value"},[_vm._v(_vm._s(_vm.$props.traitValue))])])}
var staticRenderFns = []

export { render, staticRenderFns }